export enum IdentityProvider {
  Slack = "slack",
  Teams = "teams",
}
